import type { CourseCalendarDateCustom, CourseCalendarDateDefault } from "@shared/models/course"
import type {
  PlanbookCalendarDateCustom,
  PlanbookCalendarDateDefault,
} from "@shared/models/planbook"
import type { RotationCalendarDate } from "@shared/models/rotation-calendar"
import { filter, find } from "lodash-es"

export type CustomDate = PlanbookCalendarDateCustom | CourseCalendarDateCustom
export type DefaultDate = PlanbookCalendarDateDefault | CourseCalendarDateDefault

/**
 * Find a date by Date String
 */
export function findDate<T extends CustomDate | RotationCalendarDate>(
  customDates: Array<T>,
  dateString: string
): T | undefined {
  return find(customDates, (date) => date.attributes.dateString === dateString)
}

export function filterForDatesBefore<T extends CustomDate | RotationCalendarDate>(
  customDates: Array<T>,
  effectiveDate: string
) {
  return filter(customDates, (date) => date.attributes.dateString < effectiveDate)
}
